import Api from '../../services/Api';
import Helpers from '../../js/helpers';

const getDefaultState = () => ({
  listGroundGh: [],
  listGroundEx: [],
  listCropGh: [],
  listCropEx: [],
  listIrrigationGh: [],
  listIrrigationEx: [],
  listManureGh: [],
  listManureEx: [],
  listGh: [],
  listEx: [],
  currentProject: '',
  listTextures: [],
  listFertilizers: [],
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetDatabaseState({ commit }) {
      commit('resetDatabaseState');
    },
    setCurrentProject(context, value) {
      context.commit('setCurrentProject', value);
    },
    async fetchListGround(context, value) {
      try {
        const xhr = await Api.fetchListGround();
        const listGround = JSON.parse(xhr.response);
        context.commit('fetchListGroundGh', listGround);
        context.commit('fetchListGroundEx', listGround);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchListCrop(context, value) {
      try {
        const xhr = await Api.fetchListCrop();
        const listCrop = JSON.parse(xhr.response);
        const listCropGh = [];
        const listCropEx = [];
        for (const list of listCrop) {
          if (list.type === 'GH') listCropGh.push(list);
          if (list.type === 'EX') listCropEx.push(list);
        }
        context.commit('fetchListCropGh', listCropGh.sort((a, b) => ((a.name > b.name) ? 1 : -1)));
        context.commit('fetchListCropEx', listCropEx.sort((a, b) => ((a.name > b.name) ? 1 : -1)));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchListFertilizers(context, value) {
      try {
        const xhr = await Api.fetchDatabaseFertilizers();
        const listTexture = JSON.parse(xhr.response);
        const temp = listTexture.map((item) => ({
          ...item,
          nameMedio: `${item.name} (${item.n}% N)`,
        }));
        context.commit('fetchFertilizers', temp.sort((a, b) => ((a.name > b.name) ? 1 : -1)));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchTextures(context, value) {
      try {
        const xhr = await Api.fetchDatabaseTexture();
        const listTexture = JSON.parse(xhr.response);
        context.commit('fetchTextures', listTexture.sort((a, b) => ((a.name > b.name) ? 1 : -1)));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchListIrrigation(context, value) {
      try {
        const xhr = await Api.fetchListIrrigation();
        const listIrrigation = JSON.parse(xhr.response);
        // const listIrrigationGh = [];
        // const listIrrigationEx = [];
        // for (const list of listIrrigation) {
        //   if (list.type === 'GH') listIrrigationGh.push(list);
        //   if (list.type === 'EX') listIrrigationEx.push(list);
        // }
        context.commit('fetchListIrrigationGh', listIrrigation);
        context.commit('fetchListIrrigationEx', listIrrigation);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchListManure(context, value) {
      try {
        const xhr = await Api.fetchListManure();
        const listManure = JSON.parse(xhr.response);
        // const listManureGh = [];
        // const listManureEx = [];
        // for (const list of listManure) {
        //   if (list.type === 'GH') listManureGh.push(list);
        //   if (list.type === 'EX') listManureEx.push(list);
        // }
        context.commit('fetchListManureGh', listManure);
        context.commit('fetchListManureEx', listManure);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchProjects(context) {
      try {
        const xhr = await Api.fetchProjects();
        const listProjects = JSON.parse(xhr.response);
        const listGh = [];
        const listEx = [];
        for (const listProject of listProjects) {
          if (listProject.type === 'GH') listGh.push(listProject);
          if (listProject.type === 'EX') listEx.push(listProject);
        }
        context.commit('fetchProjectsGh', listGh);
        context.commit('fetchProjectsEx', listEx);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
  },
  mutations: {
    resetDatabaseState(state) {
      Object.assign(state, getDefaultState());
    },
    fetchListGroundGh(state, value) {
      state.listGroundGh = value;
    },
    fetchListGroundEx(state, value) {
      state.listGroundEx = value;
    },
    fetchListCropGh(state, value) {
      state.listCropGh = value;
    },
    fetchListCropEx(state, value) {
      state.listCropEx = value;
    },
    fetchTextures(state, value) {
      state.listTextures = value;
    },
    fetchFertilizers(state, value) {
      state.listFertilizers = value;
    },
    fetchListIrrigationGh(state, value) {
      state.listIrrigationGh = value;
    },
    fetchListIrrigationEx(state, value) {
      state.listIrrigationEx = value;
    },
    fetchListManureGh(state, value) {
      state.listManureGh = value;
    },
    fetchListManureEx(state, value) {
      state.listManureEx = value;
    },
    fetchProjectsGh(state, value) {
      state.listGh = value;
    },
    fetchProjectsEx(state, value) {
      state.listEx = value;
    },
    setCurrentProject(state, value) {
      state.currentProject = value;
    },
  },
};
